import { useWhatsappConfiguration } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappConfiguration";
import { TriggerNodeSettings } from "./TriggerNodeV2";

function WhatsAppTriggerNodeSettings(props) {
  const { workspaceId } = props;
  const { whatsappConfiguration } = useWhatsappConfiguration(workspaceId);
  const phoneNumbers = whatsappConfiguration?.data?.phoneNumberIds || [];

  return (
    <TriggerNodeSettings
      phoneNumbers={phoneNumbers}
      {...props}
      channelType="whatsapp"
    />
  );
}

export default WhatsAppTriggerNodeSettings;
